/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BranchCode = {
    Unemployment: 'CHO',
    Mri: 'MRI',
    UPI: 'CBNO',
    RGI: 'GLI',
    Borrower: 'EMP',
    Pet: 'ANI',
    LegalProtection: 'PJ'
} as const;
export type BranchCode = typeof BranchCode[keyof typeof BranchCode];


export function instanceOfBranchCode(value: any): boolean {
    for (const key in BranchCode) {
        if (Object.prototype.hasOwnProperty.call(BranchCode, key)) {
            if (BranchCode[key as keyof typeof BranchCode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BranchCodeFromJSON(json: any): BranchCode {
    return BranchCodeFromJSONTyped(json, false);
}

export function BranchCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BranchCode {
    return json as BranchCode;
}

export function BranchCodeToJSON(value?: BranchCode | null): any {
    return value as any;
}

export function BranchCodeToJSONTyped(value: any, ignoreDiscriminator: boolean): BranchCode {
    return value as BranchCode;
}

